import React from 'react';
import Logo from './pics/Square-White-Logo-with-Cloured-Background.svg';
import Roses from './pics/roses.jpg';
import Daisies from './pics/daisies.jpg';
import Marigolds from './pics/marigolds.jpg';
import Pothos from './pics/pothos.jpg';
import AloeVera from './pics/aloe-vera.jpg';
import FiddleLeafFig from './pics/fiddle-leaf-fig.jpg';
import Cloves from './pics/cloves.jpg';
import Mint from './pics/mint.jpg';
import Thyme from './pics/thyme.jpg';

function AboutPage() {
    return(
        <>
            <body id='aboutBody'>
                <div className="container">
                <div id='headerContainer'><h1 className = "header">About Us!</h1> <img src={Logo} alt="logo" height={100} className="headerLogo"/></div>
                    <h2 className = "header mediaHeader">About Potting Around</h2>
                    <p className='p'>At Potting Around, we strive to provide Canadians with only the highest quality plants. Our dedicated employees ensure that any plant that arrives at your door will be green, healthy, and won't have any stowaway pests.</p>
                    <p className='p'>For more information about the types of plants we offer, see our Product Page.</p>
                    <p className='p'>Visit our Contact Page if you have any additional questions about our plants.</p>
                    <img className='plantImage' src={Roses} alt="roses" height={50} width={50} />
                    <img className='plantImage' src={Daisies} alt="daisies" height={50} width={50} />
                    <img className='plantImage' src={Marigolds} alt="marigolds" height={50} width={50} />
                    <img className='plantImage' src={Pothos} alt="pothos" height={50} width={50} />
                    <img className='plantImage' src={AloeVera} alt="aloe vera" height={50} width={50} />
                    <img className='plantImage' src={FiddleLeafFig} alt="fiddle leaf fig" height={50} width={50} />
                    <img className='plantImage' src={Cloves} alt="cloves" height={50} width={50} />
                    <img className='plantImage' src={Mint} alt="mint" height={50} width={50} />
                    <img className='plantImage' src={Thyme} alt="thyme" height={50} width={50} />
                </div>
            </body>
        </>
    );
}
export default AboutPage;